<template>
  <div class="popup_wrap doc_req_pop" style="width:900px; height:410px;">
    <button class="layer_close" @click="$emit('close')">close</button>
    <form
      id="frm_req_pop"
      @submit.prevent
    >
      <div class="popup_cont cod_cont_area">
        <!-- popup_cont -->
        <h1 class="page_title">
          <!-- 컨테이너 반출 요청서 -->
          {{ $t('msg.ONEX010P095.001') }}
          <span class="position_relative screen-to-pdf-hide">
            <button class="tbl_icon help" @mouseover="showToolTip()" @mouseleave="showToolTip()">{{ $t('msg.ONEX010P095.057') }}</button>
            <div v-show="toolTipActive" class="tooltip_wrap short position_absolute" style="width:360px; left:0; top:28px;"><!-- tooltip_wrap   -->
              <div class="cont"><!-- cont -->
                <p class="title">{{ $t('msg.ONEX010P095.001') }}</p><!-- 컨테이너 반출 요청서 -->
                <ul class="bul_list_sm t2">
                  <li>
                    {{ $t('msg.ONEX010P095.002') }} <br /> {{ $t('msg.ONEX010P095.003') }}
                  </li>
                </ul>
              </div><!-- cont -->
            </div><!-- tooltip_wrap // -->
          </span>
        </h1>
        <div
          v-if="delegateYn === 'Y'"
          class="content_box"
        >
          <!-- content_box -->
          <table class="tbl_row">
            <colgroup>
              <col width="200"><col>
            </colgroup>
            <tbody>
              <tr>
                <th>{{ $t('msg.ONEX010P095.004') }}</th><!-- 날짜 -->
                <td>
                  <div class="tbl_form">
                    {{ $ekmtcCommon.changeDatePattern(nowDate, '.') }}
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{ $t('msg.ONEX010P095.005') }}</th><!-- 수신 -->
                <td>{{ $t('msg.ONEX010P095.006') }}</td><!-- KOREA MARINE TRANSPORT CO., LTD. -->
              </tr>
              <tr>
                <th>{{ $t('msg.ONEX010P095.007') }}</th><!-- 발신 -->
                <td>
                  <div class="tbl_form">
                    {{ bookingInfo.shprCstNm }}
                  </div>
                  <div class="tbl_form mt5">
                    <div>
                      <span class="dv col_1">{{ formData.reqPicNm }}</span>
                      <span class="dv col_2">{{ formData.reqPicTelNo }}</span>
                      <span class="dv col_3">{{ formData.reqPicEmlAddr }}</span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{ $t('msg.ONEX010P095.008') }}</th><!-- 실화주명 -->
                <td>
                  <div class="tbl_form">
                    {{ bookingInfo.actShprCstEnm }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div><!-- content_box // -->

        <div
          v-if="delegateYn === 'Y'"
          class="content_box mt10 cod_cont_area"
        >
          <!-- content_box -->
          <table class="tbl_row">
            <colgroup>
              <col width="200"><col>
            </colgroup>
            <tbody>
              <tr>
                <th>{{ $t('msg.ONEX010P095.009') }}</th><!-- Booking No. -->
                <td>
                  <div class="tbl_form">
                    {{ bookingInfo.bkgNo }}
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{ $t('msg.ONEX010P095.010') }}</th><!-- 선적지/양하지 -->
                <td>
                  <div class="tbl_form">
                    <span class="dv col_3">
                      {{ bookingInfo.polPlcNm }}
                    </span>
                    <span class="dv col_3">
                      {{ bookingInfo.podPlcNm }}
                    </span>
                    <span class="dv col_4">

                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{ $t('msg.ONEX010P095.011') }}</th><!-- Vessel/Voyage -->
                <td>
                  <div class="tbl_form">
                    <span class="dv col_3">
                      {{ bookingInfo.vslNm }}
                    </span>
                    <span class="dv col_3">
                      {{ bookingInfo.voyNo }}
                    </span>
                    <span class="dv col_4">

                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{ $t('msg.ONEX010P095.012') }} {{ $t('msg.ONEX010P095.013') }}</th><!-- 반출 컨테이너 -->
                <td>
                  <div
                    class="tbl_form div_cntr_area screen-to-pdf-hide"
                    v-for="(vo, idx) in formData.containerList"
                    :key="'cntr_' + idx"
                    :id="'alertArea_'+ idx"
                  >
                    <span class="dv col_5">
                      <input
                        v-model="vo.cntrNo"
                        :id="'cntrNo_' + idx"
                        type="text"
                        placeholder="반출하고자 하는 컨테이너 번호"
                        @input="checkValidationCntrNo(idx)"
                        @blur="containerChk(idx)"
                      >
                    </span>
                    <span class="dv">
                      <button
                        v-if="idx === 0"
                        class="tbl_icon plus"
                        @click="addContainer()"
                      >
                        plus
                      </button>
                      <button
                        v-if="idx !== 0"
                        class="tbl_icon minus"
                        @click="removeContainer(idx)"
                      >
                        minus
                      </button>
                    </span>
                    <span class="dv col_1">From</span>
                    <span class="dv col_3">
                      <input type="text" :id="'fromTerminal_' + idx" v-model="vo.trmlNm" placeholder="From - Terminal" readonly>
                    </span>
                  </div>
                  <div
                    class="tbl_form div_cntr_area screen-to-pdf-show"
                    v-for="(vo, idx) in formData.containerList"
                    :key="'cntr_' + idx"
                    :id="'alertArea_'+ idx"
                  >
                    <p>
                      <span class="dv col_2">{{ vo.cntrNo }}</span>
                      <span class="dv col_3">{{ vo.trmlNm }}</span>
                    </p>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{ $t('msg.ONEX010P095.015') }}</th><!-- 반출 예정일 -->
                <td class="screen-to-pdf-hide">
                  <e-date-picker v-model="formData.coDt" id="coDt" @input="checkValidationInputAll()" />
                </td>
                <td class="screen-to-pdf-show">
                  <p>{{ formData.coDt }}</p>
                </td>
              </tr>
              <tr>
                <th>{{ $t('msg.ONEX010P095.017') }}</th><!-- 운송회사 정보 -->
                <td class="screen-to-pdf-hide">
                  <div class="tbl_form">
                    <span class="dv col_3">
                      <input type="text" v-model="formData.tfcoNm" @input="checkValidationInputAll()" id="tfcoNm" placeholder="업체명">
                    </span>
                    <span class="dv col_3">
                      <input type="text" v-model="formData.tfcoPicNm" @input="checkValidationInputAll()" id="tfcoPicNm" placeholder="성명">
                    </span>
                    <span class="dv">
                      <input type="text" v-model="formData.tfcoTelNo" @input="checkValidationInputAll()" id="tfcoTelNo" placeholder="전화번호">
                    </span>
                  </div>
                </td>
                <td class="screen-to-pdf-show">
                  <div class="tbl_form">
                    <span class="dv col_3">{{ formData.tfcoNm }}</span>
                    <span class="dv col_3">{{ formData.tfcoPicNm }}</span>
                    <span class="dv">{{ formData.tfcoTelNo }}</span>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{ $t('msg.ONEX010P095.018') }}</th><!-- 상하차료 정산 -->
                <td class="screen-to-pdf-hide">
                  <div class="tbl_form">
                    <span class="dv col_3">
                      <input type="text" v-model="formData.updtShprCstNm" @input="checkValidationInputAll()" id="updtShprCstNm" placeholder="화주 또는 운송사">
                    </span>
                    <span class="dv col_3">
                      <input type="text" v-model="formData.shprPicNm" @input="checkValidationInputAll()" id="shprPicNm" placeholder="담당자 성명">
                    </span>
                    <span class="dv">
                      <input type="text" v-model="formData.shprPicTelNo" @input="checkValidationInputAll()" id="shprPicTelNo" placeholder="담당자 전화번호">
                    </span>
                  </div>
                </td>
                <td class="screen-to-pdf-show">
                  <div class="tbl_form">
                    <span class="dv col_3">{{ formData.updtShprCstNm }}</span>
                    <span class="dv col_3">{{ formData.shprPicNm }}</span>
                    <span class="dv">{{ formData.shprPicTelNo }}</span>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{ $t('msg.ONEX010P095.014') }}</th><!-- 반출 사유 -->
                <td class="screen-to-pdf-hide">
                  <input type="text" v-model="formData.reqRsnCont" placeholder="반출 사유">
                </td>
                <td class="screen-to-pdf-show">
                  <p>{{ formData.reqRsnCont }}</p>
                </td>
              </tr>
            </tbody>
          </table>
          <table v-if="terminalFlag === 'Y'" class="tbl_col mt10">
            <colgroup>
              <col style="width:200px">
              <col>
              <col>
              <col>
              <col>
            </colgroup>
            <tbody>
              <tr>
                <th class="text_left" rowspan="2">{{ $t('msg.ONEX010P095.019') }}</th><!-- 추가 선적명세 (광양 반출건에만 해당 타 터미널 공란) -->
                <th>{{ $t('msg.ONEX010P095.020') }}</th><!-- 품명 -->
                <th>{{ $t('msg.ONEX010P095.021') }}</th><!-- 수량(단위포함) -->
                <th>{{ $t('msg.ONEX010P095.022') }}</th><!-- 중량 -->
                <th>{{ $t('msg.ONEX010P095.023') }}</th><!-- 화물가액(단위포함) -->
              </tr>
              <tr class="screen-to-pdf-hide">
                <td class="border_left">
                  <input type="text" v-model="reqRsnCont1" id="reqRsnCont1" placeholder="품명 기재">
                </td>
                <td>
                  <input type="text" v-model="reqRsnCont2" id="reqRsnCont2" placeholder="수량 기재">
                </td>
                <td>
                  <input type="text" v-model="reqRsnCont3" id="reqRsnCont3" placeholder="중량 기재">
                </td>
                <td>
                  <input type="text" v-model="reqRsnCont4" id="reqRsnCont4" placeholder="화물가액 기재">
                </td>
              </tr>
              <tr class="screen-to-pdf-show">
                <span class="dv col_2">{{ reqRsnCont1 }}</span>
                <span class="dv col_2">{{ reqRsnCont2 }}</span>
                <span class="dv col_2">{{ reqRsnCont3 }}</span>
                <span class="dv">{{ reqRsnCont4 }}</span>
              </tr>
            </tbody>
          </table>

          <div class="normal_box">
            <p>{{ $t('msg.ONEX010P095.024') }}</p>
            <p class="text_center mt10">
              {{ $t('msg.ONEX010P095.025') }}
            </p>
            <ol>
              <li>{{ $t('msg.ONEX010P095.026') }}</li>
              <li>{{ $t('msg.ONEX010P095.027') }}</li>
              <li>{{ $t('msg.ONEX010P095.028') }}</li>
              <li>{{ $t('msg.ONEX010P095.029') }}</li>
              <li>{{ $t('msg.ONEX010P095.030') }}</li>
            </ol>
            <p class="text_center mt10">{{ $ekmtcCommon.changeDatePattern(nowDate, '.') }}</p>
            <p class="text_center mt10">
              <span class="screen-to-pdf-hide">
                <input
                  v-model="agreeYn"
                  type="checkbox"
                  name="no"
                  id="chk1"
                  true-value="Y"
                  false-value="N"
                >
                <label for="chk1"><span class="offscreen">No</span></label>
              </span>
              <span class="screen-to-pdf-show">
                <input
                  checked="checked"
                  disabled="disabled"
                  type="checkbox"
                  name="no"
                  id="chk1_temp"
                >
                <label for="chk1_temp"><span class="offscreen">No</span></label>
              </span>
              {{ $t('msg.ONEX010P095.031') }} (<span class="ml10 mr10">{{ bookingInfo.actShprCstEnm }}</span>){{ $t('msg.ONEX010P095.032') }}
            </p>
            <p class="txt_desc mt10" style="background: none;">
              <span class="font_medium">[{{ $t('msg.ONEX010P095.033') }}]</span>
              {{ $t('msg.ONEX010P095.034') }}   <span class="txt_bar"></span> {{ $t('msg.ONEX010P095.035') }} : {{ $t('msg.ONEX010P095.036') }}<br>
              <span style="margin-left:34px;">{{ $t('msg.ONEX010P095.037') }}</span> {{ $t('msg.ONEX010P095.038') }}   <span class="txt_bar"></span> {{ $t('msg.ONEX010P095.035') }} : {{ $t('msg.ONEX010P095.039') }}<br>
              <span style="margin-left:34px;">{{ $t('msg.ONEX010P095.040') }}</span> {{ $t('msg.ONEX010P095.041') }}   <span class="txt_bar"></span> {{ $t('msg.ONEX010P095.035') }} : {{ $t('msg.ONEX010P095.042') }}<br>
              <span style="margin-left:34px;">{{ $t('msg.ONEX010P095.043') }}</span> {{ $t('msg.ONEX010P095.044') }}   <span class="txt_bar"></span> {{ $t('msg.ONEX010P095.035') }} : {{ $t('msg.ONEX010P095.045') }}
            </p>
          </div>
        </div><!-- content_box // -->

        <div
          v-if="delegateYn === 'N'"
          class="content_box"
        >
          <!-- content_box -->
          <p v-if="!(memberDetail.userCtrCd === 'KR' && $store.getters['auth/getCalcEiCatCd'] === 'O')">
            {{ $t('msg.ONEX010P095.047') }}
          </p>
          <p class="mt5">
            <span v-show="memberDetail.userCtrCd !== 'KR'"><a class="button sm" href="#" @click.prevent="excelDownload('ContainerOutRequest.xlsx')">{{ $t('msg.ONEX010P095.048') }}</a></span><!-- 컨테이너 반출 요청서 양식 다운 -->
            <span v-if="!(memberDetail.userCtrCd === 'KR' && $store.getters['auth/getCalcEiCatCd'] === 'O')" class="ml5"><a class="button sm" href="#" @click.prevent="moveDelegateReqPage()">{{ $t('msg.ONEX010P095.049') }}</a></span><!-- 위수임 신청 바로가기 -->
            <span v-if="!(memberDetail.userCtrCd === 'KR' && $store.getters['auth/getCalcEiCatCd'] === 'O')">
              <button type="button" class="tbl_icon help ml10" @click.prevent="guidePop()">{{ $t('msg.ONEX010P095.050') }}</button><!-- 도움말 -->
            </span>
          </p>

          <h2 class="content_title">{{ $t('msg.ONEX010P095.051') }}</h2><!-- 컨테이너 반출 요청서 제출 -->
          <table class="tbl_row">
            <colgroup>
              <col style="width:200px">
              <col>
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">{{ $t('msg.ONEX010P095.052') }}</th><!-- 제출 -->
                <td>
                  <div v-if="memberDetail.userCtrCd == 'KR'" class="filebox" id="file_att">
                    <a
                      class="button sm gray file"
                      @click.prevent="openEleConsReqDocPop()"
                    >
                      {{ $t('js.booking.043') }} <!-- 양식작성 -->
                    </a>
                  </div>
                  <div v-else class="filebox" id="file_att">
                    <a
                      v-if="uploadParam.length === 0"
                      class="button sm gray file"
                      @click.prevent="uploadFilePop()"
                    >
                      {{ $t('msg.ONEX010P095.053') }}
                    </a>
                    <div v-if="uploadParam.length > 0">
                      <span class="tbl_icon attach"></span>
                      <a class="text_link">{{ uploadParam[0].originalName }}</a>
                      <a
                        class="tbl_icon attdel"
                        @click="removeUploadFile()"
                      >X</a>
                    </div>
                  </div>
                </td>
                <td class="border_left_none">
                  <!--<a class="button sm" href="#">제출</a>-->
                </td>
              </tr>
            </tbody>
          </table>
          <p class="txt_desc mt10" style="background: none;">
            <span class="font_medium">[{{ $t('msg.ONEX010P095.033') }}]</span>
            {{ $t('msg.ONEX010P095.034') }}   <span class="txt_bar"></span> {{ $t('msg.ONEX010P095.035') }} : {{ $t('msg.ONEX010P095.036') }}<br>
            <span style="margin-left:34px;">{{ $t('msg.ONEX010P095.037') }}</span> {{ $t('msg.ONEX010P095.038') }}   <span class="txt_bar"></span> {{ $t('msg.ONEX010P095.035') }} : {{ $t('msg.ONEX010P095.039') }}<br>
            <span style="margin-left:34px;">{{ $t('msg.ONEX010P095.040') }}</span> {{ $t('msg.ONEX010P095.041') }}   <span class="txt_bar"></span> {{ $t('msg.ONEX010P095.035') }} : {{ $t('msg.ONEX010P095.042') }}<br>
            <span style="margin-left:34px;">{{ $t('msg.ONEX010P095.043') }}</span> {{ $t('msg.ONEX010P095.044') }}   <span class="txt_bar"></span> {{ $t('msg.ONEX010P095.035') }} : {{ $t('msg.ONEX010P095.045') }}
          </p>
        </div><!-- content_box // -->

        <div class="mt10 text_right screen-to-pdf-hide">
          <a v-show="memberDetail.userCtrCd !== 'KR'" class="button blue lg mr5" @click="reqSave()">{{ $t('msg.ONEX010P095.052') }}</a>
          <a v-if="delegateYn === 'Y'" class="button gray lg" @click="$emit('close')">{{ $t('msg.ONEX010P095.057') }}</a>
          <a v-else class="button gray lg" @click="confirmClose()">{{ $t('msg.ONEX010P095.057') }}</a>
        </div>

        <win-layer-pop v-if="delegateYn === 'Y'" class="popup_dim">
          <component
            :is="customComponent"
            v-if="customComponent"
            :parent-info="popParams"
            @close="closePopup"
            @1="selectFunc"
          />
        </win-layer-pop>

        <template v-if="delegateYn === 'N'">
          <win-layer-pop v-if="memberDetail.userCtrCd == 'KR'" ref="openPop" class="popup_dim_snd">
            <component
              :is="popComponent"
              v-if="popComponent"
              :parent-info="popParams"
              @close="closeCommonPopup"
              @callback="popCallback"
            />
          </win-layer-pop>

          <win-layer-pop v-else ref="uploadPop" class="popup_dim">
            <component
              :is="customComponent"
              v-if="customComponent"
              :parent-info="uploadParam"
              :single-file-yn="true"
              @set-dext-file-info="arrangeUploadParam"
              @close="closePopup"
            />
          </win-layer-pop>
        </template>

        <div v-show="false" id="guide_pop" v-if="delegateYn === 'N'">
          <component
            :is="customComponent"
            v-if="customComponent"
            @close="closePopup"
          />
        </div>
      </div><!-- popup_cont -->
    </form>
  </div>
</template>

<script>

import commons from '@/api/services/commons'
import docs from '@/api/rest/trans/docs'
import trans from '@/api/rest/trans/trans'
import transCommon from '@/api/rest/trans/transCommon'
import WinLayerPop from '@/pages/trans/popup/WinLayerPop'
import ContainerGuidePop from '@/pages/trans/popup/ContainerGuidePop'
import DocUploadPop from '@/pages/trans/popup/DocUploadPop'
import { rootComputed } from '@/store/helpers'
import EleConsReqDocPop from '@/pages/trans/popup/eleConsReqDocPop'
import FullContainerReqInputPop from '@/pages/trans/popup/FullContainerReqInputPop'

export default {
  name: 'FullContainerOutReqPop',
  components: {
    rootComputed,
    WinLayerPop,
    DocUploadPop,
    ContainerGuidePop,
    EDatePicker: () => import('@/components/common/EDatePicker'),
    EleConsReqDocPop,
    FullContainerReqInputPop
  },
  props: {
    parentInfo: {
      type: Object,
      default: function () {
        return {
          blNo: '',
          bkgNo: ''
        }
      }
    }
  },
  data () {
    return {
      delegateYn: '',
      ops: {
        scrollPanel: {
          speed: 300
        },
        bar: {
          showDelay: 500,
          keepShow: true,
          background: '#c1c1c1',
          opacity: 1
        }
      },
      nowDate: '',
      bookingInfo: {
        type: Object,
        default: null
      },
      cntrTypeList: [
        { cdNm: 'Dry', cd: 'GP', rmk: '20/40' },
        { cdNm: 'HIGH CUBE', cd: 'HC', rmk: '40/45' },
        { cdNm: 'REEFER', cd: 'RF', rmk: '20' },
        { cdNm: 'REEFER HIGH CUBE', cd: 'RH', rmk: '40' },
        { cdNm: 'TANK', cd: 'TK', rmk: '20/40' },
        { cdNm: 'OPEN TOP', cd: 'OT', rmk: '20/40' },
        { cdNm: 'FLAT RACK', cd: 'FR', rmk: '20/40' },
        { cdNm: 'SUPER RACK', cd: 'SR', rmk: '40' }
      ],
      agreeYn: 'N',
      toDayDate: '', // 현재날짜
      picNmh: '',
      toolTipActive: false,
      cstInfoList: [],
      cntrList: [],
      selectFunc: null,
      customComponent: null,
      popParams: {},
      uploadParam: [],
      terminalFlag: 'N',
      formData: {
        entPicNo: '',
        reqPicNm: '',
        reqPicTelNo: '',
        reqPicEmlAddr: '',
        reqRsnCont: '',
        coDt: '',
        containerList: [
          {
            // 반출 컨테이너 번호
            cntrNo: '',
            // 반출 터미널 명
            trmlNm: '',
            // 반출 터미널 코드
            trmlCd: '',
            // 반출예정일
            coDt: ''
          }
        ],
        //운송사
        tfcoNm: '',
        tfcoPicNm: '',
        tfcoTelNo: '',
        //상하차료 정산
        updtShprCstNm: '',
        shprPicNm: '',
        shprPicTelNo: '',
        uploadFileInfos: []
      },
      //추가 선적명세 - 품명
      reqRsnCont1: '',
      //추가 선적명세 - 수량
      reqRsnCont2: '',
      //추가 선적명세 - 중량
      reqRsnCont3: '',
      //추가 선적명세 - 화물가액
      reqRsnCont4: '',
      excelData: [
        {
          sample: 'Sample'
        }
      ],
      popComponent: null
    }
  },
  computed: {
    ...rootComputed
  },
  watch: {
    parentInfo () {
      if (this.$ekmtcCommon.isNotEmpty(this.$props.parentInfo.bkgNo)) {
        this.setDelegateYn(this.$props.parentInfo.bkgNo)
      }
    }
  },
  created () {
    this.initPop()
  },
  methods: {
    async initPop () {
      //bkgNo없으면 blNo가져오기 처리
      const parentInfo = this.parentInfo
      if (this.$ekmtcCommon.isEmpty(parentInfo.blNo) && this.$ekmtcCommon.isEmpty(parentInfo.bkgNo)) {
        const TH = this
        this.$ekmtcCommon.alertCallback(this.$t('msg.ONEX070G050.004'), () => {
          TH.$emit('close')
        })
      }
      if (this.$ekmtcCommon.isEmpty(parentInfo.blNo)) {
        await trans.findBkgBlInfo(parentInfo.bkgNo).then(res => {
          if (res.headers.respcode === 'C0000') {
            const result = res.data

            let blNo = ''
            if (this.$ekmtcCommon.isNotEmpty(result.blNo)) {
              blNo = result.blNo
            }

            parentInfo.blNo = blNo
          }
        })
      }

      if (this.$ekmtcCommon.isNotEmpty(parentInfo.bkgNo)) {
        this.init()
      } else {
        const TH = this
        this.$ekmtcCommon.alertCallback(this.$t('msg.ONEX070G050.014'), () => {
          TH.$emit('close')
        })
      }
    },
    async init () {
      const TH = this
      const parentInfo = TH.parentInfo

      //현재 날짜 가져오기
      this.toDayDate = await this.$ekmtcCommon.getToday()

      // 위수임여부 가져오기
      await this.setDelegateYn(parentInfo.bkgNo)

      // 로그인한 정보를 이용하여 프로필 정보 가져오기
      if (!this.auth.userId) {
        await this.$ekmtcCommon.asyncAlertMessage({ message: this.$t('msg.REPORT_PDF.115') }) // 로그인을 확인해주세요.
        this.$emit('close')
        return
        } else {
        const data = this.selectedProfile
        this.formData.entPicNo = data.picNo
        this.formData.reqPicNm = data.picNm
        this.formData.reqPicEmlAddr = data.emlAddr

        let usrTelNo = data.telPlcNo || ''

        if (this.$ekmtcCommon.isNotEmpty(data.telOfcNo)) {
          usrTelNo += '-' + data.telOfcNo
        }

        if (this.$ekmtcCommon.isNotEmpty(data.telNo)) {
          usrTelNo += '-' + data.telNo
        }

        this.formData.reqPicTelNo = usrTelNo
      }

      const arrPromise = [
        commons.getServerTime().then(res => {
          if (res.data !== undefined && res.data !== null) {
            TH.nowDate = res.data.substring(0, 8)
          }
        }),
        commons.getCstInfo().then(res => {
          this.cstInfoList = res
        })
      ]

      arrPromise.push(
        docs.getReqDocBooking(parentInfo.bkgNo).then(async res => {
          const result = res.data
          await TH.setBookingInfo(result)
        })
      )

      await Promise.all(arrPromise)
    },
    async setDelegateYn (bkgNo) {
      // CD_ID = 01007 (30: 수출 ALL, 38: 컨테이너 반출요청)
      await transCommon.getBkgDelegateYn({ bkgNo: bkgNo, arrCstGrpCatCd: ['30', '38'] }).then(async (res) => {
        if (res.data === 'Y') {
          this.delegateYn = 'N'
        } else {
          this.delegateYn = 'N'
        }
      })
    },
    async setBookingInfo (result) {
      this.bookingInfo = result
      const TH = this
      if (this.$ekmtcCommon.isNotEmpty(this.bookingInfo.blNo)) {
        const blNo = this.bookingInfo.blNo
        await docs.getBkgContainerInfo(blNo).then(res => {
          const cntrList = res.data

          if (cntrList !== undefined && cntrList.length > 0) {
            cntrList.forEach(c => {
              const cdInfo = TH.cntrTypeList.filter(vo => vo.cd === c.cntrTypCd)

              if (cdInfo !== undefined && cdInfo.length > 0) {
                c.cntrTypNm = cdInfo[0].cdNm
              }
            })

            TH.formData.containerList = cntrList
          }
        })
      }
    },
    addContainer (flag) {
      const defInfo = {
        cntrNo: '',
        cntrTypCd: '',
        cntrTypNm: '',
        fromTerminal: ''
      }

      this.formData.containerList.push(defInfo)
    },
    removeContainer (idx) {
      const containerList = this.formData.containerList
      containerList.splice(idx, 1)

      const containerLen = containerList.length
      if (containerLen === 0) {
        this.addContainer()
      }
    },
    checkValidationCntrAll () {
      let isOk = true
      const containerList = this.formData.containerList

      for (let idx = 0; idx < containerList.length; idx++) {
        if (!this.checkValidationCntrNo(idx)) {
          isOk = false
        }
      }

      return isOk
    },
    checkValidationInputAll () {
      let isOk = true
      const prefix = ['tfcoNm', 'tfcoPicNm', 'tfcoTelNo', 'coDt', 'updtShprCstNm', 'shprPicNm', 'shprPicTelNo']

      prefix.forEach(el => {
        if (!this.checkValidationInputInfo(el)) {
          isOk = false
        } else if (!this.checkValidationDate()) {
          isOk = false
        }
      })

      return isOk
    },
    //반출예정일 오늘날짜 이후로 체크
    checkValidationDate () {
      let isOk = true
      const frm = document.querySelector('#frm_req_pop')
      const selector = frm.querySelector('#coDt')

      const today = Number(this.toDayDate.replaceAll('-', ''))
      const value = Number(selector.value.replaceAll('.', ''))

      this.$ekmtcCommon.hideErrorTooltip(selector)

      if (today > value) {
        this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.ONEX010P095.058')) // 현재날짜 이후로 선택해 주십시오.
        isOk = false
      }

      return isOk
    },
    checkValidationInputInfo (id) {
      let isOk = true
      const frm = document.querySelector('#frm_req_pop')
      const selector = frm.querySelector('#' + id)

      this.$ekmtcCommon.hideErrorTooltip(selector)

      if (this.$ekmtcCommon.isEmpty(selector.value)) {
        this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.147'))
        isOk = false
      }

      return isOk
    },
    //Null체크
    checkValidationCntrNo (idx) {
      let isOk = true
      const frm = document.querySelector('#frm_req_pop')
      const selector = frm.querySelector('#cntrNo_' + idx)
      const selector2 = frm.querySelector('#alertArea_' + idx)

      this.$ekmtcCommon.hideErrorTooltip(selector2)

      if (this.$ekmtcCommon.isEmpty(selector.value)) {
        this.$ekmtcCommon.showErrorTooltip(selector2, this.$t('msg.CSBK100.147'))
        isOk = false
      }

      return isOk
    },
    //컨테이너 넘버 체크
    async containerChk (idx) {
      const containerList = this.formData.containerList
      // 자동으로 대문자 변환
      containerList[idx].cntrNo = containerList[idx].cntrNo.toUpperCase()
      const cntrNo = containerList[idx].cntrNo
      if (cntrNo.length === 0) return

      // 컨테이너 넘버 길이 체크
      if (cntrNo.length > 10) {
        // 컨테이너 넘버 체크
        await docs.containerChk(cntrNo)
          .then(response => {
            if (response.data === 'N') {
              this.$ekmtcCommon.alertCallback(this.$t('art.CMATK363'), function () {
                containerList[idx].cntrNo = ''
                containerList[idx].trmlNm = ''
                containerList[idx].trmlCd = ''
              })
            } else {
              // 해당 컨테이너의 가장 최근에 GATE-IN 되었던 터미널 가져오기
              docs.findGtiTerminal(cntrNo).then(res => {
                if (this.$ekmtcCommon.isNotEmpty(res.data)) {
                  containerList[idx].trmlNm = res.data.trmlNm
                  containerList[idx].trmlCd = res.data.trmlCd

                  //터미널이 광양일 경우 하단 테이블 나오게 flag 처리
                  for (let i = 0; i < containerList.length; i++) {
                    if (containerList[i].trmlCd === 'KAN') {
                      this.terminalFlag = 'Y'
                    } else {
                      this.terminalFlag = 'N'
                    }
                  }

                  // 이후 중복체크
                  this.fnChkCntrNo(idx)
                } else {
                  this.$ekmtcCommon.alertDefault(this.$t('msg.ONEX010P095.059')) // 해당 컨테이너의 현재 터미널 정보를 불러올 수 없습니다.
                }
              })
            }
        })
      } else {
        this.$ekmtcCommon.alertCallback(this.$t('art.CMATK363'), function () {
          containerList[idx].cntrNo = ''
          containerList[idx].trmlNm = ''
          containerList[idx].trmlCd = ''
        })
      }
    },
    //컨테이너 중복체크
    fnChkCntrNo (idx, flag) {
      const containerList = this.formData.containerList
      const cntrNo = containerList[idx].cntrNo
      if (cntrNo.length === 0) return

      for (let i = 0; i < containerList.length; i++) {
        if (i !== idx && this.$ekmtcCommon.isNotEmpty(containerList[i].cntrNo) && containerList[i].cntrNo.trim() === cntrNo.trim()) {
          this.$ekmtcCommon.alertCallback(this.$t('msg.CSBK100.247'), function () {
            containerList[idx].cntrNo = ''
            containerList[idx].trmlNm = ''
            containerList[idx].trmlCd = ''
          })
        }
      }
    },
    async reqSave () {
      let isOk = true
      const TH = this
      const formData = TH.formData

      if (TH.delegateYn === 'Y') {
        if (!TH.checkValidationCntrAll()) {
          isOk = false
        }
        if (!TH.checkValidationInputAll()) {
          isOk = false
        }
      }

      if (TH.delegateYn === 'N') {
        formData.uploadFileInfos = this.uploadParam.map((item) => {
          if (item.new !== true) {
            item.fileId = item.asFileId
          }
          return item
        })

        TH.$delete(formData, 'containerList')

        if (TH.delegateYn === 'N' && formData.uploadFileInfos.length === 0) {
          const attachSelector = document.querySelector('#file_att')
          TH.$ekmtcCommon.showErrorTooltip(attachSelector, TH.$t('msg.CSBK100.147'))
          isOk = false
        }
      }

      if (isOk) {
        if (TH.agreeYn !== 'Y' && TH.delegateYn === 'Y') {
          TH.$ekmtcCommon.alertDefault(this.$t('msg.ONEX010P095.046'))
          return
        }

        let successFlag = true

        formData.vslCd = TH.bookingInfo.vslCd
        formData.voyNo = TH.bookingInfo.voyNo
        formData.polCtrCd = TH.bookingInfo.polCtrCd
        formData.polPortCd = TH.bookingInfo.polPortCd
        formData.podCtrCd = TH.bookingInfo.podCtrCd
        formData.podPortCd = TH.bookingInfo.podPortCd
        formData.shprCstNo = TH.bookingInfo.shprCstNo
        formData.shprCstNm = TH.bookingInfo.shprCstNm
        formData.blNo = TH.parentInfo.blNo
        formData.bkgNo = TH.parentInfo.bkgNo
        formData.reqCatCd = '16'

        // 위수임 Y일때 - 광양일때 추가 테이블 정보 넣기
        if (TH.delegateYn === 'Y') {
          if (TH.terminalFlag === 'Y') {
            formData.reqRsnCont = '반출사유 및 요청사항: ' + formData.reqRsnCont + '품명: ' + TH.reqRsnCont1 + '수량: ' + TH.reqRsnCont2 + '중량: ' + TH.reqRsnCont3 + '화물가액: ' + TH.reqRsnCont4
          }

          // coDt 기입
          for (let i = 0; i < formData.containerList.length; i++) {
            formData.containerList[i].coDt = formData.coDt
          }
        }

        if (this.delegateYn === 'Y') {
          const frm = document.querySelector('#frm_req_pop')
          const ele = frm.querySelector('.cod_cont_area')
          this.$ekmtcCommon.elemAddClass(ele, 'screen_shot')

          await this.$ekmtcCommon.screenToPdf({ cssSelector: '.cod_cont_area' })
            .then(async (res) => {
              const reqData = new FormData()
              const fileName = this.$t('msg.ONEX010P095.001') + '.pdf'
              reqData.append('files', res.output('blob'), fileName)

              await commons.tempFileUpload(reqData).then((result) => {
                  console.log(result)
                  const fileId = result.data.fileId

                  const fileObj = {
                    fileId: fileId,
                    originalName: fileName
                  }

                  formData.uploadFileInfos.push(fileObj)
                })
                .catch(err => {
                  console.log(err)
                })

                TH.$ekmtcCommon.elemRemoveClass(ele, 'screen_shot')
            })
        }
        let result = null
        await docs.reqDocSubmit(formData).then(res => {
          if (res.headers.respcode !== 'C0000') {
            successFlag = false
          }
          result = res.data
        }).catch(() => {
          successFlag = false
        }).finally(() => {
          if (successFlag && result !== null) {
            TH.$ekmtcCommon.alertCallback(TH.$t('msg.CSBK100.236'), function () {
              TH.$emit('selectFunc', result)
              TH.$emit('close')
            })
          } else {
            TH.$ekmtcCommon.alertDefault(TH.$t('msg.CSBK100.237'))
          }
        })
      }
    },
    uploadFilePop () {
      const uploadParam = this.uploadParam

      this.$set(this, 'uploadParam', uploadParam)
      this.openPopup('DocUploadPop')
    },
    guidePop () {
      this.openPopup('ContainerGuidePop')
    },
    openPopup (compNm) {
      this.customComponent = compNm
      this.$ekmtcCommon.layerOpen('.doc_req_pop .popup_dim')
    },
    closePopup (compNm) {
      const elemGuidPopup = document.querySelector('#guide_pop')
      this.customComponent = null
      this.selectFunc = null

      if (compNm !== 'confirmClose') {
        elemGuidPopup.style.display = 'none'
      } else {
        this.$emit('close')
      }

      this.$ekmtcCommon.layerClose('.doc_req_pop .popup_dim')
    },
    arrangeUploadParam () {
      const attachSelector = document.querySelector('#file_att')
      this.$ekmtcCommon.hideErrorTooltip(attachSelector)
      this.uploadParam.map((item) => (item.newFlag = item.new))
    },
    removeUploadFile () {
      this.uploadParam.splice(0, 1)
      this.customComponent = null
    },
    showToolTip () {
      console.log(this.toolTipActive)
      this.toolTipActive = !this.toolTipActive
    },
    async moveDelegateReqPage () {
      const TH = this
      // 위수임 신청 페이지로 이동하시겠습니까?
      if (await TH.$ekmtcCommon.asyncAlertMessage({ message: TH.$t('msg.ONEX060P012.089'), useConfirmBtn: true })) {
        TH.$emit('close')
        TH.$router.push({ name: 'import-business-agency-information-main' })
      }
    },
    async confirmClose () {
      //if (await this.$ekmtcCommon.asyncAlertMessage({ message: this.$t('msg.ONEX020P130.062'), useConfirmBtn: true })) {
        this.$emit('close')
      //}
    },
    async excelDownload (fileName) {
      console.log('#### excel Download ####')

      const data = {
        fileNm: fileName,
        blNo: this.parentInfo.bkgNo
      }

      if (this.$ekmtcCommon.isNotEmpty(this.parentInfo.bkgNo)) {
        //using blob download
        const result = await docs.getExcelDownload(data)
        console.log('##### excelDownload #####')
        console.log(result)
        //blob 객체 생성
        const blob = new Blob([result.data], { type: result.headers['content-type'] })

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          //IE에서 동작
          window.navigator.msSaveOrOpenBlob(result.data, fileName)
        } else {
          //<a>태그에 URL화 시킨 blob객체를 연결시킨 후 다운로드
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')

          link.href = url
          link.target = '_self'
          link.download = fileName
          link.click()

          //url 사용 후 메모리에서 제거
          window.URL.revokeObjectURL(url)
        }
      }
    },
    openCommonPopup (compNm) {
      this.popComponent = compNm
      this.$ekmtcCommon.layerOpen('.doc_req_pop .popup_dim_snd')
    },
    closeCommonPopup (compNm) {
      this.popComponent = null

      this.$ekmtcCommon.layerClose('.doc_req_pop .popup_dim_snd')
    },
    openEleConsReqDocPop () {
      this.popParams.reqCatCd = '16'
      this.popParams.bkgNo = this.parentInfo.bkgNo
      this.popParams.blNo = this.parentInfo.blNo

      this.openCommonPopup('EleConsReqDocPop')
    },
    popCallback (callParams) {
      console.log('popCallback @@@@@ ', callParams)

      this.openCommonPopup('FullContainerReqInputPop')
    }
  }
}
</script>

<style scoped>
.doc_req_pop {width:910px; height: 600px; overflow-y: scroll;}
.doc_req_pop > .layer_close {z-index: 10;}
.div_cntr_area + .div_cntr_area {margin-top: 5px;}
.text_link {color: #000; padding-left: 2px;}
.text_link:hover {text-decoration: underline !important;}
.attdel {cursor: pointer;}
</style>
